import loadModuleOnElement from "../../utils/loadModuleOnElement";

const loader = () => import("./module");

export default function initProductsLoader(context) {
    loadModuleOnElement('img[usemap ^="#image-map-"]', loader, context);
    return context;
}
